import Swiper from "swiper/bundle";

export const setupInfo = ($productTemplate, product) => {
  // Handle the product info set up
  const $productInfo = $productTemplate.querySelector(
    ".product-template__info"
  );

  const setPriceElements = () => {
    const currentPrice = product.getCurrentPrice();
    const currentPriceValue = product.getCurrentPrice(false);
    const subscriptionPrice = product.getSubscriptionPrice();
    const onetimePrice = product.getOnetimePrice();

    const subscriptionSavingPercentage =
      product.getSubscriptionSavingPercentage();

    const $productPrices = $productInfo.querySelectorAll(
      ".product-template__prices .product-template__price, .product__price"
    );

    const $productPricesSubscriptions = $productInfo.querySelectorAll(
      ".product__price-subscription"
    );
    const $productPricesOnetimes = $productInfo.querySelectorAll(
      ".product__price-onetime"
    );

    const $productSubscriptionSavings = $productInfo.querySelectorAll(
      ".product__subscription-saving"
    );

    const $productPointsTotals = $productInfo.querySelectorAll(
      ".product__points-total"
    );
    const $productPointsValues = $productInfo.querySelectorAll(
      ".product__points-value"
    );

    if (currentPrice) {
      $productPrices.forEach(($productPrice) => {
        $productPrice.textContent = currentPrice;
      });
    }

    if (subscriptionPrice) {
      $productPricesSubscriptions.forEach(($productPricesSubscription) => {
        $productPricesSubscription.textContent = subscriptionPrice;
      });
    }

    if (onetimePrice) {
      $productPricesOnetimes.forEach(($productPricesOnetime) => {
        $productPricesOnetime.textContent = onetimePrice;
      });
    }

    if (subscriptionSavingPercentage) {
      $productSubscriptionSavings.forEach(($productSubscriptionSaving) => {
        $productSubscriptionSaving.textContent = subscriptionSavingPercentage;
      });
    }

    const value = Math.floor(currentPriceValue / 100) * 15;
    $productPointsTotals.forEach(($productPointsTotal) => {
      $productPointsTotal.textContent = value;
    });
    $productPointsValues.forEach(($productPointsValue) => {
      $productPointsValue.textContent = product.formatMoney(value);
    });
  };

  const $productTempalteAddToCart = $productInfo.querySelector(
    ".product-template__add-to-cart"
  ) || $productInfo.querySelector(
    ".product-givy__add-to-cart"
  );

  const $productVariants = $productInfo.querySelectorAll(
    ".product-template__variants .product-template__variant"
  );

  const $plansSelect = $productInfo.querySelector(
    ".purchase-type__plans .plans__select"
  );

  // Setting up the Variants logic
  $productVariants.forEach(($productVariant, variantIndex) => {
    const setOption = (optionPosition, optionValue) => {
      switch (optionPosition) {
        case 1:
          product.setOption1(optionValue);
          break;
        case 2:
          product.setOption2(optionValue);
          break;
        case 3:
          product.setOption3(optionValue);
          break;
      }

      const newVariant = product.setVariantByOption(
        optionPosition,
        optionValue
      );

      // Reset Givy form when variant changes
      const $givyContainer = $productInfo.querySelector('.product-givy');
      if ($givyContainer) {
        const $givyAlpine = $givyContainer.querySelector('[x-data]');
        if ($givyAlpine && $givyAlpine._x_dataStack && $givyAlpine._x_dataStack[0]) {
          try {
            // Call the resetForm method if it exists
            if (typeof $givyAlpine._x_dataStack[0].resetForm === 'function') {
              $givyAlpine._x_dataStack[0].resetForm();
            }
          } catch (error) {
            console.warn('Error resetting Givy form:', error);
          }
        }
      }

      $productVariants.forEach(($productVariantInner, variantIndex) => {
        const optionPositionInner = parseInt(
          $productVariantInner.dataset.optionPosition
        );
        let optionValueInner = "";

        switch (optionPositionInner) {
          case 1:
            optionValueInner = product.getOption1();
            break;
          case 2:
            optionValueInner = product.getOption2();
            break;
          case 3:
            optionValueInner = product.getOption3();
            break;
        }

        const $productOptions = $productVariantInner.querySelector(
          ".product-template__options"
        );

        // Handle dropdown selects (only actual select elements)
        if ($productOptions.classList.contains("product-template__options--select")) {
          const $optionSelect = $productOptions.querySelector("select.options__select");
          if ($optionSelect) {
            $optionSelect.value = optionValueInner;
          }
        }

        // Handle radio inputs (regardless of container class)
        const $optionRadios = $productOptions.querySelectorAll("input[type='radio'].options__radio");
        if ($optionRadios.length > 0) {
          $optionRadios.forEach(($optionRadio) => {
            if ($optionRadio.value === optionValueInner) {
              $optionRadio.checked = true;
            } else {
              $optionRadio.checked = false;
            }
          });
        }

        // Handle button-style options (fallback for non-radio buttons)
        const $optionButtons = $productOptions.querySelectorAll(".product-template__options--buttons .options__button");
        if ($optionButtons.length > 0 && $optionRadios.length === 0) {
          $optionButtons.forEach(($optionButton) => {
            if ($optionButton.dataset.optionHandle == optionValueInner) {
              $optionButton.classList.add("options__button--active");
            } else {
              $optionButton.classList.remove("options__button--active");
            }
          });
        }
      });
      if ($productTempalteAddToCart && newVariant.available == true) {
        $productTempalteAddToCart.classList.remove(
          "bg-light-grey",
          "border-light-grey",
          "button--disabled"
        );
        $productTempalteAddToCart.classList.add(
          "bg-charcoal",
          "border-charcoal"
        );
        $productTempalteAddToCart.disabled = false;
      } else if ($productTempalteAddToCart) {
        $productTempalteAddToCart.classList.remove(
          "bg-charcoal",
          "border-charcoal"
        );
        $productTempalteAddToCart.classList.add(
          "bg-light-grey",
          "border-light-grey",
          "button--disabled"
        );
        $productTempalteAddToCart.disabled = true;
      }

      const $coattendButton =
        $productTemplate.querySelector(".coattend-button");
      if ($coattendButton) {
        $coattendButton.dataset.coattendVariantId = newVariant.id;
      }
    };

    const $productOptions = $productVariant.querySelector(
      ".product-template__options"
    );

    // Handle dropdown selects (only actual select elements, not radio inputs)
    if ($productOptions.classList.contains("product-template__options--select")) {
      const $optionSelect = $productOptions.querySelector("select.options__select");
      if ($optionSelect) {
        $optionSelect.addEventListener("change", (event) => {
          event.preventDefault();
          setOption(
            parseInt($productVariant.dataset.optionPosition),
            event.target.value,
          );
          setPriceElements();
        });
      }
    }

    // Handle radio inputs (regardless of container class)
    const $optionRadios = $productOptions.querySelectorAll("input[type='radio'].options__radio");
    if ($optionRadios.length > 0) {
      $optionRadios.forEach(($optionRadio) => {
        $optionRadio.addEventListener("change", (event) => {
          event.preventDefault();
          setOption(
            parseInt($productVariant.dataset.optionPosition),
            event.target.value,
          );
          setPriceElements();
        });
      });
    }

    // Handle button-style options
    const $optionButtons = $productOptions.querySelectorAll(".options__button");
    if ($optionButtons.length > 0 && $optionRadios.length === 0) {
      $optionButtons.forEach(($optionButton) => {
        $optionButton.addEventListener("click", (event) => {
          event.preventDefault();
          setOption(
            parseInt($productVariant.dataset.optionPosition),
            $optionButton.dataset.optionHandle
          );
          setPriceElements();

          const $variantInput = document.querySelector(
            "input[data-variant-id]"
          );

          if ($variantInput) {
            const selectedVaraint = product.getSelectedVaraint();
            $variantInput.value = selectedVaraint.id;
          }
        });
      });
    }
  });

  // Setting up the Quantity logic
  const $productQuantity = $productInfo.querySelector(
    ".product-template__quantity"
  );
  const $productQuantityValue = $productQuantity?.querySelector(
    ".product-template__quantity-value"
  );
  const $productQuantityDecrease = $productQuantity?.querySelector(
    ".product-template__quantity-decrease"
  );
  $productQuantityDecrease?.addEventListener("click", (event) => {
    event.preventDefault();
    $productQuantityValue.textContent = product.decreaseQuantity();
    setPriceElements();
  });
  const $productQuantityIncrease = $productQuantity?.querySelector(
    ".product-template__quantity-increase"
  );
  $productQuantityIncrease?.addEventListener("click", (event) => {
    event.preventDefault();
    $productQuantityValue.textContent = product.increaseQuantity();
    setPriceElements();
  });

  // Setting up the Purchase Type logic
  const $productPurchaseTypes = $productInfo.querySelectorAll(
    ".product-template__purchase-types .product-template__purchase-type"
  );
  $productPurchaseTypes.forEach(($productPurchaseType) => {
    const $purchaseTypeButton = $productPurchaseType.querySelector(
      ".purchase-type__button"
    );
    $purchaseTypeButton.addEventListener("click", (event) => {
      event.preventDefault();
      $productPurchaseTypes.forEach(($productPurchaseTypeInner) => {
        const $purchaseTypeButtonInner =
          $productPurchaseTypeInner.querySelector(".purchase-type__button");
        if (event.target == $purchaseTypeButtonInner) {
          $productPurchaseTypeInner.classList.add(
            "product-template__purchase-type--active"
          );
          product.setPurchaseType($productPurchaseTypeInner.dataset.typeHandle);
          setPriceElements();
        } else {
          $productPurchaseTypeInner.classList.remove(
            "product-template__purchase-type--active"
          );
        }
      });
      product.setPlanById($plansSelect.value);
    });
    if (
      $productPurchaseType.classList.contains(
        "product-template__purchase-type--active"
      )
    ) {
      product.setPurchaseType($productPurchaseType.dataset.typeHandle);
    }
  });

  $plansSelect?.addEventListener("change", (event) => {
    event.preventDefault();
    product.setPlanById($plansSelect.value);
  });

  $productTempalteAddToCart?.addEventListener("click", (event) => {
    event.preventDefault();
    product.addToCart();
  });


  // Handle Givy add-to-cart buttons
  const $givyAddToCartButtons = $productInfo.querySelectorAll(".product-givy__add-to-cart");
  $givyAddToCartButtons.forEach(($button, index) => {

    // Remove any existing event listeners to prevent duplicates
    $button.replaceWith($button.cloneNode(true));
    const $newButton = $productInfo.querySelectorAll(".product-givy__add-to-cart")[index];

    $newButton.addEventListener("click", async (event) => {
      event.preventDefault();

      // Check if button is disabled
      if ($newButton.disabled ||
        $newButton.classList.contains('cursor-not-allowed') ||
        $newButton.style.opacity === '0.5' ||
        window.getComputedStyle($newButton).opacity === '0.5' ||
        $newButton.hasAttribute('disabled') ||
        $newButton.getAttribute('disabled') === 'true') {
        return;
      }

      // Check Alpine.js validation state FIRST
      const $givyContainer = $productInfo.querySelector('.product-givy');
      if ($givyContainer) {
        const $givyAlpine = $givyContainer.querySelector('[x-data]');
        if ($givyAlpine && $givyAlpine._x_dataStack && $givyAlpine._x_dataStack[0]) {
          const alpineData = $givyAlpine._x_dataStack[0];
          try {
            // Check if no tab is selected
            if (!alpineData.activeTab) {
              alert('Please select a gift delivery method first.');
              return;
            }

            // Check if form is valid
            if (typeof alpineData.isFormValid === 'function') {
              const isValid = alpineData.isFormValid();
              if (!isValid) {
                alert('Please fill in all required fields.');
                return;
              }
            } else {
              alert('Please select a gift delivery method and fill in all required fields.');
              return;
            }
          } catch (error) {
            console.warn('Error checking Alpine.js validation:', error);
            alert('Please select a gift delivery method and fill in all required fields.');
            return;
          }
        } else {
          alert('Please select a gift delivery method first.');
          return;
        }
      } else {
        alert('Please select a gift delivery method first.');
        return;
      }

      // Get the send method from the button data attribute
      const sendMethod = $newButton.dataset.givySendMethod;

      // Find the active tab and collect form data
      const $activeTab = $productInfo.querySelector('[x-show*="activeTab"]:not([style*="display: none"])');

      if (!$activeTab) {
        alert('Please select a gift delivery method first.');
        return;
      }

      const properties = {};

      // Collect all form inputs from the active tab
      const $inputs = $activeTab.querySelectorAll('input, textarea, select');

      $inputs.forEach(($input) => {
        if ($input.value.trim()) {
          properties[$input.name] = $input.value.trim();
        }
      });

      // Add required send method
      properties['_givy_send_method'] = sendMethod;

      // Add to cart with Givy properties
      const cart = window.Carbon.Cart;
      const variantId = product.selectedVariant.id;
      const quantity = product.quantity;

      // Validate that we have a valid variant
      if (!variantId) {
        alert('Please select a valid product variant before adding to cart.');
        return;
      }

      // Add to cart with Givy properties using direct fetch
      try {
        const cartRequest = {
          items: [{
            id: parseInt(variantId),
            quantity: parseInt(quantity),
            properties: properties
          }],
          sections: cart.sections
        };

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartRequest),
        });

        const data = await response.json();

        if (response.ok) {
          // Success - re-render cart sections
          cart.reRenderSections(data.sections);

          // Handle cart aside display
          if (cart.useCartAside) {
            const $cartAsideBackground = document.querySelector(".cart-aside__background");
            const $cartAside = $cartAsideBackground.querySelector("aside.cart-aside");
            const $body = document.querySelector("body");
            $body.classList.add("overflow-y-hidden");
            $cartAsideBackground.classList.remove("pointer-events-none");
            $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
            $cartAside.classList.remove("translate-x-full", "ponter-events-none", "hidden");
          } else {
            window.location = `/cart`;
          }
        } else {
          // Handle 422 errors - check if item was actually added
          const cartResponse = await fetch("/cart.js");
          const cartData = await cartResponse.json();

          // Look for the item in the cart
          const givyItem = cartData.items.find(item =>
            item.variant_id == variantId &&
            item.properties &&
            item.properties._givy_send_method
          );

          if (givyItem) {
            // Re-render cart sections
            cart.reRenderSections(cartData);

            // Handle cart aside display
            if (cart.useCartAside) {
              const $cartAsideBackground = document.querySelector(".cart-aside__background");
              const $cartAside = $cartAsideBackground.querySelector("aside.cart-aside");
              const $body = document.querySelector("body");
              $body.classList.add("overflow-y-hidden");
              $cartAsideBackground.classList.remove("pointer-events-none");
              $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
              $cartAside.classList.remove("translate-x-full", "ponter-events-none", "hidden");
            } else {
              window.location = `/cart`;
            }
          } else {
            alert('There was an error adding the gift to your cart. Please try again.');
          }
        }
      } catch (error) {
        console.error('Error adding Givy gift to cart:', error);
        alert('There was an error adding the gift to your cart. Please try again.');
      }
    });
  });

  // Reusable function to handle flyout interactions
  function setupFlyout(buttonSelector, flyoutSelector) {
    const $button = $productInfo.querySelector(buttonSelector);
    const $flyout = $productInfo.querySelector(flyoutSelector);

    if ($button && $flyout) {
      const $topClose = $flyout.querySelector(".top__close");

      // Open flyout
      $button.addEventListener("click", (event) => {
        event.preventDefault();
        $flyout.classList.remove("opacity-0", "pointer-events-none");
      });

      // Close flyout via close button
      if ($topClose) {
        $topClose.addEventListener("click", (event) => {
          event.preventDefault();
          $flyout.classList.add("opacity-0", "pointer-events-none");
        });
      }

      // Close flyout via backdrop click
      $flyout.addEventListener("click", (event) => {
        event.preventDefault();
        if (event.target === $flyout) {
          $flyout.classList.add("opacity-0", "pointer-events-none");
        }
      });
    }
  }

  // Setup all flyouts
  setupFlyout(".option__grind-button", ".info__grind-flyout");
  setupFlyout(".option__gifting-button", ".info__gifting-flyout");
  setupFlyout(".option__subcription-button", ".info__subscription-flyout");
  setupFlyout(".option__delivery-button", ".info__delivery-flyout");

  const $infoFields = $productInfo.querySelector(".info__fields");
  if ($infoFields) {
    const $fieldItems = $infoFields.querySelectorAll(".field__item");
    $fieldItems.forEach(($fieldItem) => {
      const $itemButton = $fieldItem.querySelector(".item__button");
      const $itemButtonArrow = $itemButton.querySelector(".button__arrow");
      const $itemContent = $fieldItem.querySelector(".item__contents");

      $itemButton.addEventListener("click", (event) => {
        event.preventDefault();

        $fieldItems.forEach(($fieldItemInner) => {
          const $itemButtonInner =
            $fieldItemInner.querySelector(".item__button");
          const $itemButtonArrowInner =
            $itemButtonInner.querySelector(".button__arrow");
          const $itemContentInner =
            $fieldItemInner.querySelector(".item__contents");

          event.preventDefault();
          if ($itemButton !== $itemButtonInner) {
            $itemContentInner.classList.add("hidden");
            $itemButtonArrowInner.classList.add("rotate-0");
            $itemButtonArrowInner.classList.remove("rotate-180");
          }
        });

        if ($itemContent.classList.contains("hidden")) {
          $itemContent.classList.remove("hidden");
          $itemButtonArrow.classList.remove("rotate-0");
          $itemButtonArrow.classList.add("rotate-180");
        } else {
          $itemContent.classList.add("hidden");
          $itemButtonArrow.classList.add("rotate-0");
          $itemButtonArrow.classList.remove("rotate-180");
        }
      });
    });
  }

  const $recomendedProducts = $productInfo.querySelector(
    ".recomended__products"
  );
  if ($recomendedProducts) {
    const $itemsMobile = $recomendedProducts.querySelector(".items__mobile");
    const $mobileSwiper = $itemsMobile.querySelector(".mobile__swiper");
    const swiperConfig = {
      direction: "horizontal",
      speed: 1000,
      slidesPerView: 1.2,
      slidesPerGroup: 1,
      spaceBetween: 12,
    };
    const mediaSwiperObject = new Swiper($mobileSwiper, swiperConfig);
  }

  const $mainBar = $productInfo.querySelector(".product-main__bar");
  if ($mainBar) {
    if ($productTempalteAddToCart) {
      window.addEventListener("scroll", (event) => {
        const buttonRect = $productTempalteAddToCart.getBoundingClientRect();

        const $siteHeader = document.querySelector("header.tribe-site-header");
        const headerRect = $siteHeader.getBoundingClientRect();

        if (buttonRect.top <= 0 + headerRect.height) {
          $mainBar.classList.remove("translate-y-full", "pointer-events-none");
          $mainBar.classList.add(
            "tribe-product-main__bar--active",
            "translate-y-0",
            "pointer-events-auto"
          );
        } else {
          $mainBar.classList.remove(
            "tribe-product-main__bar--active",
            "translate-y-0",
            "pointer-events-auto"
          );
          $mainBar.classList.add("translate-y-full", "pointer-events-none");
        }
      });

      const $wrapperButtons = $mainBar.querySelectorAll(".wrapper__button");
      console.log("$wrapperButtons", $wrapperButtons);

      $wrapperButtons.forEach(($wrapperButton) => {
        $wrapperButton.addEventListener("click", (event) => {
          event.preventDefault();
          if ($productTempalteAddToCart) {
            const buttonRect =
              $productTempalteAddToCart.getBoundingClientRect();

            const calculatedY = Math.round(
              window.scrollY + buttonRect.bottom - innerHeight + 56
            );
            window.scrollTo(0, calculatedY);
          }
        });
      });
    }
  }
};

export default setupInfo;